import { useQuery, QueryFunction } from 'react-query';
import { getAllToolsTypes, GetToolsTypesQueries, ToolType } from '../../services/apiSLTP/materials/toolsTypes';

type UseToolsTypesQueryOptions = {
    queries?: GetToolsTypesQueries;
};

const getToolsTypes: QueryFunction<ToolType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseToolsTypesQueryOptions];
    const { queries } = options;

    const response = await getAllToolsTypes(queries);
    return response.data;
};

export const useToolsTypesQuery = (options: UseToolsTypesQueryOptions) => {
    return useQuery(['toolsTypes', options], getToolsTypes);
};
